<template>
  <div>
    <div class="box">
      <div
        class="box-container"
        :title="subItem.title + '.' + subItem.fileExt"
        :style="{ 'border-color': subItem.select ? '#0199ff' : '' }"
      >
        <!--选中区域-->
        <!-- <div
                        v-if="filescalled"
                        :class="['select-container', { select: subItem.select }]"
                        @click="selectResource(subItem, index, subIndex)"
                >
                    <img src="../assets/images/resource/selected.png" v-if="subItem.select" alt="">
                    <img src="../assets/images/resource/selected-nor.png" v-else alt="">
                </div> -->
        <!--  已转换资源封面  -->
        <div
          class="res-cover"
          :style="'background-image: url(' + subItem.imgUrl + ')'"
          v-if="subItem.convertState == 1"
          @click="
            openPreview(
              subItem.resultUrl,
              subItem.imgCount,
              subItem.fileType,
              subItem.fileUrl,
              index,
              subIndex
            )
          "
        ></div>
        <!--  未转换资源封面  -->
        <template v-else>
          <!--  转换状态标识  -->
          <div
            class="res-item-header convert-fail"
            v-if="subItem.convertState == -2"
          >
            <span class="convert-fail-icon"></span>
            <span>转换失败！</span>
          </div>
          <div
            class="res-item-header convert-ing"
            v-if="subItem.convertState == -1"
          >
            <span class="convert-ing-icon"></span>
            <span>正在转换...</span>
          </div>
          <div
            class="res-item-header convert-wait"
            v-if="subItem.convertState == 0"
          >
            <span class="convert-wait-icon"></span>
            <span>等待转换...</span>
          </div>
          <div
            class="def-cover"
            :class="subItem.fileExt"
            @click="
              openPreview(
                subItem.resultUrl,
                subItem.imgCount,
                subItem.fileType,
                subItem.fileUrl,
                index,
                subIndex
              )
            "
          ></div>
        </template>
        <!-- 资源工具 -->
        <!-- <div class="res-item-toolbar">
          <span
                  v-if="shareBtn"
                  title="分享"
                  class="i-icon share-icon"
                  style="border-right: 1px solid #F0F0F0;"
                  @click="openShareModal(subItem.id)"
          ></span>
                    <a
                            class="download"
                            :href="subItem.fileUrl"
                            :download="subItem.title + '.' + subItem.fileExt"
                            style="display: flex;"
                    >
                        <span title="下载" class="i-icon download-icon" style="border-right: 1px solid #F0F0F0;"></span>
                    </a>
                    <span
                            title="编辑"
                            class="i-icon edit-icon"
                            style="border-right: 1px solid #F0F0F0;"
                            @click="editResource(subItem.id)"
                    ></span>
                    <span title="删除" class="i-icon delete-icon" @click="removeResource(subItem.id)"></span>
                </div> -->
        <audio
          id="audioPlayer"
          class="res-media res-media-audio"
          controls
          autoplay
          v-if="subItem.isPlaying"
        >
          <source :src="subItem.fileUrl" type="audio/mpeg" />
          您的浏览器不支持 audio 元素。
        </audio>
      </div>
      <div class="resource-title-box">
        <!--标签-->
        <div
          class="type-label"
          :style="{
            background: selectBgByTypeName(subItem.typeName)[1],
            color: selectBgByTypeName(subItem.typeName)[0],
          }"
          v-if="subItem.typeName != ''"
        >
          {{ subItem.typeName }}
        </div>
        <div class="title" :title="subItem.title + '.' + subItem.fileExt">
          {{ subItem.title + "." + subItem.fileExt }}
        </div>
        <div class="description">
          <div style="float: left">
            {{ subItem.fileSize ? subItem.fileSize : "暂无大小" }}
          </div>
          <div style="float: right">{{ subItem.createTimeFormat }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "resource-list-img",
  props: {
    subItem: {
      type: Object,
      default: {},
    },
    filescalled: {
      type: Boolean,
      default: true,
    },
    shareBtn: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: "",
    },
    subIndex: {
      type: Number,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 修改资源信息
     */
    editResource(id) {
      this.$emit("editResource", id);
    },
    /**
     * 删除资源
     */
    removeResource(ids) {
      this.$emit("removeResource", ids);
    },
    /**
     * 选中资源或者取消选中
     */
    selectResource(item, index, subIndex) {
      this.$emit("selectResource", item, index, subIndex);
    },
    /**
     * 打开预览
     */
    openPreview(resultUrl, count, type, src, index, subIndex) {
      this.$emit("openPreview", resultUrl, count, type, src, index, subIndex);
    },
    /**
     *打开分享弹框
     */
    openShareModal(currentId) {
      this.$emit("openShareModal", currentId);
    },
    /**
     * 根据标签名选择不同的背景色
     */
    selectBgByTypeName(name) {
      let backgroundEnum = {
        试卷: ["#725FE5", "#F2F0FF"],
        习题: ["#0DBE8E", "#EDFCF8"],
        教案: ["#24A9FF", "#EDF6FC"],
        课件: ["#F5B453", "#FCF6ED"],
        素材: ["#F56353", "#FCEFED"],
        导学案: ["#2FA82F", "#F2EDFC"],
        微课: ["#FF5797", "#FFF0F6"],
        其它: ["#BE5FE5", "#F8EDFC"],
        undefined: ["", ""],
      };
      return backgroundEnum[name] || ["#fff", "#fff"];
    },
  },
  mounted() {},
};
</script>
